import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

import styles from './GlassCard.module.scss';

const paddingClass = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
} as const;

interface GlassCardProps {
  children: ReactNode;
  padding?: keyof typeof paddingClass;
  className?: string;
}

export function GlassCard({ children, padding = 'md', className }: GlassCardProps) {
  return <div className={cn(styles.glassCard, paddingClass[padding], className)}>{children}</div>;
}
